import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// context
import { useListingContext } from '@/context/listing';

// hooks
import useListingPopstate from '@/hooks/listing/useListingPopstate';
import useListingLoad from '@/hooks/listing/useListingLoad';
import useFetchListingData from '@/hooks/listing/useFetchListingData';
import useListingPagination from '@/hooks/listing/useListingPagination';

// components
import FilterBtn from '@/braun/components/atoms/FilterBtn';
import SortBtn from '@/braun/components/atoms/SortBtn';
import GridListBtn from '@/braun/components/atoms/GridListBtn';
import FiltersHead from '@/braun/components/organisms/FiltersHead';
import FiltersTags from '@/braun/components/organisms/FiltersTags';
import FiltersList from '@/braun/components/organisms/FiltersList';

const Filters = ({ categoryCode, categoryName, sortData, hasLoadMore }) => {
  const { t } = useTranslation();
  const [
    { sorts, areFiltersOpen, filtersData },
    { toggleFilters, clearFilters, setQuerySort, pushQuery },
  ] = useListingContext();

  // hooks
  useListingLoad({ categoryCode, sortData, hasLoadMore });
  useFetchListingData(categoryCode);
  useListingPopstate();
  useListingPagination();

  return (
    <>
      <FiltersHead
        categoryName={categoryName}
        count={filtersData.count}
        label={t('listing:listing.total.results.label')}
      />
      <div className='bra-toolbarPlp'>
        <div className='bra-toolbarPlp__wrap'>
          <FilterBtn
            toggle={toggleFilters}
            label={t('listing:listing.filter.cta.label')}
          />
          <SortBtn
            sorts={sorts}
            setQuerySort={setQuerySort}
            label={t('listing:listing.sort.cta.label')}
          />
          <GridListBtn />
        </div>
        <FiltersTags
          breadcrumbs={filtersData.breadcrumbs}
          onClearFilters={clearFilters}
          onRemove={pushQuery}
          clearAllLabel={t('listing:listing.clear.filters.cta.label')}
        />
        <FiltersList
          open={areFiltersOpen}
          filtersData={filtersData}
          onChangeFilter={pushQuery}
          onToggleFilters={toggleFilters}
          applyFilterLabel={t('listing:listing.apply.filters.cta.label')}
        />
      </div>
    </>
  );
};

Filters.propTypes = {
  categoryCode: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  hasLoadMore: PropTypes.string.isRequired,
  sortData: PropTypes.string.isRequired,
};

Filters.defaultProps = {};

export default Filters;
